import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import { lunaSearchApi } from './luna';
import type { SearchApi } from './SearchApi';

const SearchApiContext = createContext<SearchApi>(lunaSearchApi);

interface SearchApiProviderProps {
  api?: SearchApi;
  children: ReactNode;
}

function SearchApiProvider({ api = lunaSearchApi, children }: SearchApiProviderProps): JSX.Element {
  return (
    <SearchApiContext.Provider value={api}>
      {children}
    </SearchApiContext.Provider>
  );
}

function useSearchApi(): SearchApi {
  return useContext(SearchApiContext);
}

export { SearchApiProvider, useSearchApi };
